<form [formGroup]="cesionarioForm" (ngSubmit)="onSubmit()" #cesionarioFormRef="ngForm">

    <div class="modal-body">
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Rut</label>
                <div class="col-9">
                    <input type="text" name="rutString" id="rutString" formControlName="rutString" class="form-control">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('rutString').invalid || cesionarioForm.get('rutString').dirty )"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('rutString').hasError('VerificacionRutValidator')">Rut inválido
                        </div>
                        <div *ngIf="cesionarioForm.get('rutString').errors?.required">Campo requerido</div>
                        <div *ngIf="cesionarioForm.get('rutString').errors?.maxLength">Mucho numero</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Razón Social</label>
                <div class="col-9">
                    <input type="text" name="razonSocial" id="razonSocial" formControlName="razonSocial"
                        class="form-control" [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('razonSocial').invalid ||  cesionarioForm.get('razonSocial').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('razonSocial').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Telefono</label>
                <div class="col-9">
                    <input type="number" name="telefono" id="telefono" formControlName="telefono" class="form-control"
                        [maxlength]="9" [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('telefono').invalid ||  cesionarioForm.get('telefono').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('telefono').errors?.required">Campo requerido</div>
                        <div *ngIf="cesionarioForm.get('telefono').errors?.max">9 numeros requeridos</div>
                        <div *ngIf="cesionarioForm.get('telefono').errors?.min">9 numeros requeridos</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Dirección</label>
                <div class="col-9">
                    <input type="text" name="direccion" id="direccion" formControlName="direccion" class="form-control"
                        [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('direccion').invalid ||  cesionarioForm.get('direccion').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('direccion').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Nombre Contacto</label>
                <div class="col-9">
                    <input type="text" name="nombreContacto" id="nombreContacto" formControlName="nombreContacto"
                        class="form-control" [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('nombreContacto').invalid ||  cesionarioForm.get('nombreContacto').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('nombreContacto').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Correo Electrónico</label>
                <div class="col-9">
                    <input type="text" name="correo" id="correo" formControlName="correo" class="form-control"
                        [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="cesionarioFormRef.submitted &&( cesionarioForm.get('correo').invalid ||  cesionarioForm.get('correo').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="cesionarioForm.get('correo').errors?.required">Campo requerido</div>
                        <div *ngIf="cesionarioForm.get('correo').hasError('wrongEmail')">Correo inválido</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="!detailMode">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">{{cesionarioToEdit?"Guardar":"Generar"}}</span>
        </button>
        <!-- <button type="button" id="add-contact-item" class="btn btn-warning add-contact-item" (click)="onSubmitThenContract(cesionarioFormRef,$event)" *ngIf="!clientToEdit && permissions.getPermission('30-20-16').asignado">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Contrato</span>
         </button> -->
        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>